/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { VisionWindowManager } from './manager';

export interface VisionWindowConfig {
    id: string;
    width: number;
    height: number;
    x: number;
    y: number;
    title: string;
}

export class VisionWindow {
    visible!: boolean;
    manager: VisionWindowManager;
    window!: dhtmlXWindowsCell;
    modal!: boolean;

    constructor(manager: VisionWindowManager, config: VisionWindowConfig) {
        this.manager = manager;

        
        if (this.manager.windows.has(config.id)) {
            return;
        }

        this.visible = false;
        this.modal = false;
        this.window = manager.createWindow(config.id, config.x, config.y, config.width, config.height);
        (this.window as any).controller = this; // eslint-disable-line
        this.manager.windows.set(config.id, this);

        this.window.attachEvent('onClose', (win) => {
            this.manager.windows.delete(win.getId());
            return true;
        });
    }

    isVisible(): boolean {
        return this.visible;
    }

    show(): void {
        this.visible = true;
        this.window.show();
        if (this.modal == true) {
            this.window.setModal(true);
        }
    }

    hide(): void {
        this.visible = false;
        this.window.hide();
        if (this.modal == true) {
            this.window.setModal(false);
        }
    }
}
